var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2808 1.28079L3.98777 7.57379L1.69477 5.28079C1.50617 5.09863 1.25357 4.99784 0.991372 5.00012C0.729175 5.0024 0.478362 5.10757 0.292954 5.29297C0.107546 5.47838 0.00237726 5.72919 9.88378e-05 5.99139C-0.00217958 6.25359 0.0986148 6.50619 0.280773 6.69479L3.28077 9.69479C3.4683 9.88226 3.72261 9.98758 3.98777 9.98758C4.25294 9.98758 4.50725 9.88226 4.69477 9.69479L11.6948 2.69479C11.8769 2.50619 11.9777 2.25359 11.9754 1.99139C11.9732 1.72919 11.868 1.47838 11.6826 1.29297C11.4972 1.10757 11.2464 1.0024 10.9842 1.00012C10.722 0.997839 10.4694 1.09863 10.2808 1.28079Z",
    fill: "#14CC52"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check-green.e317103378820abd9f3a2b55337696d7.svg";
export { ForwardRef as ReactComponent };